// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"44f8238a","213":"e82c2f91","239":"19c1c1ed","455":"618b144c"}[chunkId] + ".chunk.js";
};